import { CmsComponentData, Paragraph } from '@boels/models';
import { of } from 'rxjs';

export const mockParagraph: Paragraph = {
  content:
    '<div><h1>Heading 1</h1><h2>Heading 2</h2><h3>Heading 3</h3></div><div><a href="https://google.com">google link</a><div><a href="product">products paragraph router link</a></div></div><div><p>Sed quae blanditiis sit iusto recusandae ut velit cumque qui neque porro.</p><p>Et dolorum galisum cum consequatur quis aut reprehenderit perspiciatis.</p></div>',
};

export const mockParagraphComponentData: CmsComponentData<Paragraph> = {
  data$: of(mockParagraph),
};
